import { Component, Input } from '@angular/core';
import moment from 'moment';

@Component({
    selector: 'redispatch-dashboard-datenaktualisierung',
    templateUrl: './dashboard-datenaktualisierung.component.html',
    styleUrls: [
        './dashboard-datenaktualisierung.component.scss',
    ],
    standalone: false,
})
export class DashboardDatenaktualisierungComponent {

    @Input()
    public lastUpdated?: string = null;

    public DATE_VALIDTIY = 7;

    constructor() { }

    public lastUpdatedIsNull() {
        return this.lastUpdated === null;
    }

    public checkDataValidity() {
        if (!this.lastUpdatedIsNull() && this.lastUpdated !== undefined) {
            let pastDate = moment().subtract(this.DATE_VALIDTIY, 'days').toISOString();
            return moment(this.lastUpdated).isBefore(pastDate);
        }
        return false;
    }

}
